import React, { useCallback, useEffect, useState } from 'react';
import useMyFormState from '../../hooks/useMyFormState';
import Cell from '../widgets/Cell';
import useReserveEntity from '../../hooks/useReserveEntity';
import { isValidEmail, isValidPersonName, isValidUsername } from '../../hooks/useValidation';
import FormButton from '../widgets/FormButton';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import { useOrganListenerContext } from '../../providers/OrganListenerContextProvider';
import './InviteMember.css';

const InviteMemberForm = (withInvite) => {
  const {myTeamData}          = useOrganListenerContext();    
  const {handleAddError, 
         handleRemoveError, 
         submitEnabled, 
         setSubmitEnabled, 
         getFormModel, 
         updateFormField, 
         reload}              = useMyFormState();
  const {reserveEntity}       = useReserveEntity();
  const [model, setModel]     = useState({});
  const [fresh, setFresh]     = useState(false);

  const refreshMe  = useCallback(()=>setFresh(prev => !prev), []);
  const {sendMessage} = useWebSocketCaller();
  

  //------[  Effect Initial  ]------
  //
  useEffect(()=>{
    if (myTeamData) {
      //console.log('[InviteMemberForm Effect] [myTeamData: %s]', JSON.stringify(myTeamData, null, 2));      
      updateFormField('toTeamId', myTeamData.teamId);
      updateFormField('username', '');
      
      // TODO: Remove it? Check if this is necessary. because the refresh is already done in useMyFormState.
      refreshMe();
    }
  }, [myTeamData, getFormModel, refreshMe, updateFormField]);


  //------[  Effect WithInvite   ]------
  //
  useEffect(()=>{
    if (withInvite?.withInvite) {
      //console.log('[InviteMemberForm Effect] [withInvite: %s]', JSON.stringify(withInvite, null, 2));
      const invite = withInvite.withInvite;
      updateFormField('userEmail', invite.toEmail);
      updateFormField('firstName', invite.toFirstName);
      updateFormField('username', invite.toUsername);
      updateFormField('toTeamId', myTeamData.teamId);

      setModel(prev => ({...prev, ...getFormModel()}));
      //refreshMe();
    }
  },[withInvite, myTeamData.teamId, updateFormField, refreshMe, getFormModel]);

  //------[   Effect Refresh Model   ]------
  //
  useEffect(()=>{
    setModel({...getFormModel()});
  }, [reload, getFormModel]);


  //------[  Handle Reserve Field  ]------
  //
  const handleReserveField = async (path, valueToReserve) => {
    updateFormField(path, valueToReserve);
    return await reserveEntity(path, valueToReserve);
  }


  //------[  Handle Send Invitation  ]------
  //
  const handleSendInvitation = useCallback(() => {    
    setSubmitEnabled(false);

    sendMessage('invite', {
        'toEmail': model.userEmail,
        'toFirstName': model.firstName, 
        'toTeamId': model.toTeamId,
        'toUsername': model.username,
        'whenClickedNotifyMe': true, 
        'whenClickedHoldForMyApproval': false
    });
  },[sendMessage, setSubmitEnabled, model.userEmail, model.firstName, model.toTeamId, model.username]);
  

  return (
    <div className='inviteMemberForm'>
      <div className='inviteHeader'>Invite users to {myTeamData.name}</div>
      <div className='inviteInputPair'>
        <div className='inviteTitle'>
          Invite to email
        </div>
        <div className='inviteCell'>
          <Cell path='userEmail' addError={handleAddError} removeError={handleRemoveError} saveMe={handleReserveField} validateMe={isValidEmail}      isRequired={true} key='userEmail'>{model.userEmail}</Cell>
        </div>
      </div>

      <div className='inviteInputPair'>
        <div className='inviteTitle'>
          First Name
        </div>
        <div className='inviteCell'>
          <Cell path='firstName' addError={handleAddError} removeError={handleRemoveError} saveMe={updateFormField}    validateMe={isValidPersonName} isRequired={true} key='firstName'>{model.firstName}</Cell>
        </div>
      </div>

      <div className='inviteInputPair'>
        <div className='inviteTitle'>Username</div>
        <div className='inviteCell'>
          <Cell path='username' addError={handleAddError} removeError={handleRemoveError} saveMe={handleReserveField} validateMe={isValidUsername} key='username' isRequired={false}>{model.username}</Cell>
        </div>
      </div>

      <FormButton isLocked={!submitEnabled} onClick={handleSendInvitation} key='sendInvite'>Send Invitation</FormButton>
    </div>
  );
};

export default React.memo(InviteMemberForm);